import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "@components"
import { useMarketplacesLBBReportForm } from "../../ReportForm/@hooks"


export default function CreateReportButton() {
    const { handleOpenForm } = useMarketplacesLBBReportForm()

    return (
        <Box componet="span" data-tour="lbb-details-create-report">
            <ActionButton
                label="Create New Report"
                icon="pen-to-square"
                onClick={handleOpenForm}
            />
        </Box>
    )
}
